<template>
  <div class="enquiry-dashboard">
    <v-row>
      <v-col md="8" v-if="false">
        <v-card flat class="px-4">
          <v-card-text>
            <div class="d-flex align-center">
              <div class="text-h5 font-weight-bold text-uppercase py-4">
                Quotation by Status
                <v-chip class="mx-2 white--text" color="green"> Top 5 </v-chip>
              </div>
              <v-spacer />
              <v-btn
                v-if="false"
                outlined
                color="blue"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3 w-25"
                style="width: 130px !important"
              >
                <v-select
                  :items="jobTypeList"
                  v-model="jobType"
                  hide-details
                  :disabled="issueCountLoadingNew"
                  item-color="cyan"
                  class="pt-0 mt-0 black--texr"
                >
                </v-select>
              </v-btn>
              <v-btn
                outlined
                color="blue"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3 w-25"
                style="width: 130px !important"
              >
                <v-select
                  :items="durationList"
                  v-model="customerDuration"
                  hide-details
                  :disabled="issueCountLoadingNew"
                  item-color="cyan"
                  class="pt-0 mt-0 black--texr"
                >
                </v-select>
              </v-btn>
            </div>
            <div id="chart">
              <apexchart
                type="bar"
                height="350"
                :options="jobByEngineerchartOptions"
                :series="jobByEngineerseries"
                @dataPointSelection="onBarClick"
              ></apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card flat class="px-4 h-100">
          <v-card-text>
            <div class="d-flex align-center">
              <div class="text-h5 font-weight-bold text-uppercase py-4">
                Quotation by Sales
                <v-chip class="mx-2 white--text" color="green"> Top 5 </v-chip>
              </div>
              <v-spacer />
              <v-btn
                outlined
                color="blue"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3 w-25"
                style="width: 130px !important"
              >
                <v-select
                  :items="durationList"
                  v-model="customerDuration"
                  hide-details
                  :disabled="issueCountLoadingNew"
                  item-color="cyan"
                  class="pt-0 mt-0 black--texr"
                >
                </v-select>
              </v-btn>

              <v-btn
                outlined
                color="blue"
                @click="resetFilterQuotationSales('sales')"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3 w-25"
                style="width: 20px !important"
              >
                <v-icon> mdi-refresh </v-icon>
              </v-btn>
            </div>
            <div class="card-custom dash_card">
              <div class="dash_bottom">
                <div class="v_list">
                  <ul class="px-2">
                    <li>
                      <strong class="w-50">Sales Name</strong>
                      <strong class="w-25"
                        >{{ SelectedquotationStatus }} Quote#</strong
                      >
                      <strong class="w-25 text-end">Value</strong>
                    </li>
                  </ul>
                  <ul class="px-2">
                    <!-- here -->

                    <template v-if="!countLoading">
                      <template v-if="quotationPerson.length > 0">
                        <li
                          v-for="(issue, index) in quotationPerson"
                          :key="index"
                          class="cursor-pointer py-1 px-2"
                          :class="{
                            'bg-cyan lighten-3': activeIndex === index,
                          }"
                          @click="onBarClick(index, issue)"
                        >
                          <div class="w-50">
                            <span
                              class="svg-icon svg-icon-xl"
                              :class="{
                                'svg-icon-primary': activeIndex === index,
                              }"
                            >
                              <inline-svg
                                :src="$assetURL('media/custom-svg/right.svg')"
                              />
                            </span>
                            <strong
                              :class="{
                                'grey--text': activeIndex != index,
                              }"
                              >{{ issue.name }}</strong
                            >
                            <v-icon
                              size="24"
                              class="ms-1"
                              v-if="activeIndex === index"
                              color="green"
                              >mdi-check-circle</v-icon
                            >
                          </div>
                          <div class="w-2">
                            <v-avatar
                              size="25"
                              class="white--text"
                              :color="issue.color"
                              >{{ issue.quotationNo }}</v-avatar
                            >
                          </div>
                          <div class="w-25 text-end">
                            <strong
                              :class="{
                                'grey--text': activeIndex != index,
                              }"
                              >$ {{ issue.value }}</strong
                            >
                          </div>
                        </li>
                      </template>
                      <template v-else>
                        <div
                          class="align-center justify-center"
                          style="margin-left: 50px; margin-top: 10px"
                        >
                          <p class="m-0 py-15 row-not-found text-center">
                            <img
                              :src="$assetURL('media/error/empty.png')"
                              class="row-not-found-image"
                            />
                            Uhh... no quotation available yet.
                          </p>
                          <!-- <em class="text--secondary text-subtitle-1">No quotation's sales available yet. </em> -->
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <!-- <li v-for="n in 5" :key="n" class="py-1 px-2"> -->

                      <!-- <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  class="mt-5"
                  height="4"
                ></v-progress-linear> -->
                      <div
                        class="d-flex align-center justify-center"
                        style="min-height: 100px"
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary darken-5"
                          size="80"
                        ></v-progress-circular>
                      </div>
                      <!-- </li> -->
                    </template>

                    <!-- here -->
                  </ul>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card flat class="px-3 h-100">
          <v-card-text>
            <div class="d-flex align-top pt-4">
              <div>
                <div class="text-h5 font-weight-bold text-uppercase">
                  Sales Person
                </div>
                <div class="font-size-20 me-4 grey--text">
                  Engineers are experts who use their technical skills.
                </div>
              </div>
              <v-spacer />
              <v-btn
                outlined
                color="blue"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3"
                style="width: 130px !important"
              >
                <v-select
                  :items="engineerdurationList"
                  v-model="engcustomerDuration"
                  hide-details
                  :disabled="issueCountLoadingNew"
                  item-color="cyan"
                  class="pt-0 mt-0 black--texr"
                >
                </v-select>
              </v-btn>
            </div>
            <div class="enginer-profile">
              <div class="swiper-container">
                <div class="swiper">
                  <div class="swiper-wrapper">
                    <!-- Slide 1 -->
                    <template v-if="!countLoading">
                      <template
                        v-if="
                          lodash.isEmpty(slides) == false && slides.length > 0
                        "
                      >
                        <div
                          v-for="(slide, index) in slides"
                          :key="index"
                          :class="`swiper-slide swiper-slide--${slide.swipeCount}`"
                        >
                          <div class="slide-content">
                            <v-avatar size="80">
                              <v-img :src="slide.avatar" />
                            </v-avatar>
                            <h4 class="white--text mt-3">{{ slide.name }}</h4>
                          </div>
                          <div class="author">
                            <v-chip
                              :style="{
                                height: '25px',
                                border: '1px solid #fff',
                              }"
                              class="rank white-text"
                              :color="slide.rankColor"
                              text-color="white"
                            >
                              <v-icon v-if="slide.rankIcon" color="white">{{
                                slide.rankIcon
                              }}</v-icon>
                              <span class="text-h6">{{ slide.rankText }}</span>
                            </v-chip>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div
                          class="align-center justify-center"
                          style="margin-left: 50px; margin-top: 10px"
                        >
                          <!-- <em class="text--secondary text-subtitle-1">No sales persons info available yet.</em> -->
                          <p class="m-0 ml-7 py-15 row-not-found text-center">
                            <img
                              :src="$assetURL('media/error/empty.png')"
                              class="row-not-found-image"
                            />
                            Uhh... no sales person info available yet.
                          </p>
                        </div>
                      </template>
                    </template>
                    <template v-else>
                      <!-- <em class="text--secondary text-subtitle-1">No sales persons info available yet.</em> -->
                      <v-progress-linear
                        color="primary"
                        indeterminate
                        rounded
                        class="mt-5"
                        height="4"
                      ></v-progress-linear>
                    </template>
                  </div>
                  <!-- Swiper Navigation -->
                  <div class="swiper-pagination"></div>
                </div>
                <!-- Navigation Buttons -->
                <!-- <div class="swiper-button-prev">
                    <v-icon color="blue">mdi-arrow-left</v-icon>
                  </div>
                  <div class="swiper-button-next">
                    <v-icon color="blue">mdi-arrow-right</v-icon>
                  </div> -->
              </div>
              <div class="swiper-container d-none">
                <div class="swiper">
                  <div class="swiper-wrapper">
                    <!-- Slide 1 -->
                    <div class="swiper-slide swiper-slide--one">
                      <div class="slide-content">
                        <v-avatar size="80">
                          <v-img
                            src="https://cdn.vuetifyjs.com/images/john.png"
                          ></v-img>
                        </v-avatar>
                        <h4 class="white--text mt-3">Jane Eyre</h4>
                      </div>
                      <div class="author">
                        <v-chip
                          style="height: 25px; border: 1px solid #fff"
                          class="rank white-text"
                          color="#ffd700"
                          text-color="white"
                        >
                          <v-icon color="">mdi-crown</v-icon>
                          <span class="text-h6">Rank 1</span>
                        </v-chip>
                      </div>
                    </div>

                    <!-- Slide 2 -->
                    <div class="swiper-slide swiper-slide--two">
                      <div class="slide-content">
                        <v-avatar size="80">
                          <v-img
                            src="https://cdn.vuetifyjs.com/images/lists/2.jpg"
                          ></v-img>
                        </v-avatar>
                        <h4 class="white--text mt-3">Jane Eyre</h4>
                      </div>
                      <div class="author">
                        <v-chip
                          style="height: 25px; border: 1px solid #fff"
                          class="rank white-black"
                          color="#C0C0C0"
                          text-color="white"
                        >
                          <span class="text-h6">Rank 2</span>
                        </v-chip>
                      </div>
                    </div>

                    <!-- Slide 3 -->
                    <div class="swiper-slide swiper-slide--three">
                      <div class="slide-content">
                        <v-avatar size="80">
                          <v-img
                            src="https://cdn.vuetifyjs.com/images/john.png"
                          ></v-img>
                        </v-avatar>
                        <h4 class="white--text mt-3">Jane Eyre</h4>
                      </div>
                      <div class="author">
                        <v-chip
                          style="height: 25px; border: 1px solid #fff"
                          class="rank white-text"
                          color="#CD7F32"
                          text-color="white"
                        >
                          <span class="text-h6">Rank 3</span>
                        </v-chip>
                      </div>
                    </div>

                    <!-- Slide 4 -->
                    <div class="swiper-slide swiper-slide--four">
                      <div class="slide-content">
                        <v-avatar size="80">
                          <v-img
                            src="https://cdn.vuetifyjs.com/images/lists/2.jpg"
                          ></v-img>
                        </v-avatar>
                        <h4 class="white--text mt-3">Jane Eyre</h4>
                      </div>
                      <div class="author">
                        <v-chip
                          style="height: 25px; border: 1px solid #fff"
                          class="rank white-black"
                          color="#C0C0C0"
                          text-color="white"
                        >
                          <span class="text-h6">Rank 2</span>
                        </v-chip>
                      </div>
                    </div>

                    <!-- Slide 5 -->
                    <div class="swiper-slide swiper-slide--five">
                      <div class="slide-content">
                        <v-avatar size="80">
                          <v-img
                            src="https://cdn.vuetifyjs.com/images/john.png"
                          ></v-img>
                        </v-avatar>
                        <h4 class="white--text mt-3">Jane Eyre</h4>
                      </div>
                      <div class="author">
                        <v-chip
                          style="height: 25px; border: 1px solid #fff"
                          class="rank white-text"
                          color="#ffd700"
                          text-color="white"
                        >
                          <v-icon color="">mdi-crown</v-icon>
                          <span class="text-h6">Rank 1</span>
                        </v-chip>
                      </div>
                    </div>

                    <!-- Slide 6 -->
                    <div class="swiper-slide swiper-slide--six">
                      <div class="slide-content">
                        <v-avatar size="80">
                          <v-img
                            src="https://cdn.vuetifyjs.com/images/lists/2.jpg"
                          ></v-img>
                        </v-avatar>
                        <h4 class="white--text mt-3">Jane Eyre</h4>
                      </div>
                      <div class="author">
                        <v-chip
                          style="height: 25px; border: 1px solid #fff"
                          class="rank white-black"
                          color="#CD7F32"
                          text-color="white"
                        >
                          <span class="text-h6">Rank 3</span>
                        </v-chip>
                      </div>
                    </div>
                  </div>

                  <!-- Swiper Navigation -->
                  <div class="swiper-pagination"></div>
                </div>
                <!-- If we need navigation buttons -->
                <div class="swiper-button-prev">
                  <v-icon color="blue">mdi-arrow-left</v-icon>
                </div>
                <div class="swiper-button-next">
                  <v-icon color="blue">mdi-arrow-right</v-icon>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4">
        <v-card flat class="py-3 px-3 h-100">
          <v-card-text>
            <div class="d-flex align-center pb-3">
              <div class="text-h5 font-weight-bold text-uppercase">
                Quotation
              </div>
              <v-spacer />

              <v-btn
                outlined
                color="blue"
                @click="resetFilterQuotationSales('quotation')"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3 w-25"
                style="width: 20px !important"
              >
                <v-icon> mdi-refresh </v-icon>
              </v-btn>
            </div>

            <div id="chart">
              <apexchart
                type="donut"
                width="420"
                :options="quoStatuschartOptions"
                :series="quoStatusseries"
                @dataPointSelection="onBarClickQuotation"
              ></apexchart>
            </div>
            <div class="d-flex align-center justify-space-between" v-if="false">
              <div
                v-for="(status, index) in quotationStatuses"
                :key="index"
                cols=""
              >
                <div class="d-inline-block text-center">
                  <div class="text-h6 fw-500 mb-2 grey--text">
                    {{ status.label }}
                  </div>
                  <div
                    :class="status.textClass"
                    class="text-h3 font-weight-bold mt-1"
                  >
                    {{ status.value }}
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card flat class="px-3">
          <v-card-text>
            <div class="d-flex align-center">
              <div class="text-h5 font-weight-bold text-uppercase pt-4">
                New & Closed /rejected Value for 6 months
              </div>
              <v-spacer />
              <v-btn
                outlined
                color="blue"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3"
              >
                <v-select
                  :items="durationList"
                  v-model="isDuration"
                  hide-details
                  :disabled="issueCountLoadingNew"
                  item-color="cyan"
                  class="pt-0 mt-0 black--texr"
                >
                </v-select>
              </v-btn>
              <v-btn
                outlined
                color="blue"
                @click="resetFilterQuotationSales('job-acpt-rej')"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3 w-25"
                style="width: 20px !important"
              >
                <v-icon> mdi-refresh </v-icon>
              </v-btn>
            </div>

            <div id="chart">
              <apexchart
                type="line"
                height="350"
                :options="newClosedJobschartOptions"
                :series="newClosedJobsseries"
              >
              </apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <!-- style="
            background-image: url(/media/bg/dots-structure-vector.jpg);
            background-size: cover;
            background-position: bottom;
          " -->
      <v-col md="12">
        <v-card flat class="px-3 py-4">
          <v-card-text>
            <div class="d-flex align-center pb-4">
              <div>
                <div class="text-h5 font-weight-bold text-uppercase pb-4">
                  Invoices
                </div>
                <div class="font-size-20">
                  Invoices detail the itemized list of goods or services
                  provided, including costs, payment terms.
                </div>
              </div>
            </div>

            <div class="invoice">
              <v-layout class="dashboard-top-button px-3 overflow-hidden">
                <v-flex
                  v-for="(item, index) in invoicestatuses"
                  :key="index"
                  class="mx-4"
                >
                  <v-card
                    outlined
                    :color="`${item.color} lighten-5`"
                    :style="`border-color: ${getBgColor(item.color)}!important`"
                  >
                    <v-card-text>
                      <div class="text-h6 fw-500">{{ item.label }}</div>
                      <div class="d-flex align-center">
                        <div
                          :class="`text-h4 font-weight-bold ${item.textColor} mt-1`"
                        >
                          {{ formatMoney(item.value) }}
                        </div>
                        <v-spacer />
                      </div>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12">
        <v-card flat class="px-3">
          <v-card-text>
            <div class="d-flex align-center">
              <div class="text-h5 font-weight-bold text-uppercase pt-4">
                New/Collected/Due Amount for 6 months
              </div>
              <v-spacer />
              <v-btn
                outlined
                color="blue"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3"
              >
                <v-select
                  :items="durationList"
                  v-model="isInvoicesCollectedDuration"
                  hide-details
                  :disabled="issueCountLoadingNew"
                  item-color="cyan"
                  class="pt-0 mt-0 black--texr"
                >
                </v-select>
              </v-btn>
              <v-btn
                outlined
                color="blue"
                @click="resetFilterQuotationSales('invoice-acpt-rej')"
                class="text-start rounded custom-menu-select py-1 btn-shadow-hover me-3 w-25"
                style="width: 20px !important"
              >
                <v-icon> mdi-refresh </v-icon>
              </v-btn>
            </div>
            <div id="chart">
              <apexchart
                type="line"
                height="350"
                :options="newInvoiceClosedJobschartOptions"
                :series="newInvoiceClosedJobsseries"
              >
              </apexchart>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Swiper from "swiper";
import { QUERY } from "@/core/services/store/request.module";
import { toWords } from "number-to-words";
import CommonMixin from "@/core/plugins/common-mixin.js";

// import "swiper/swiper-bundle.css";
export default {
  name: "ProjectStatus",
  mixins: [CommonMixin],

  data() {
    return {
      SelectedquotationStatus: "All",
      slides: [],
      issueCountLoadingNew: null,
      countLoading: null,
      activeIndex: null,
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      draftCount: 2,
      sentCount: 2,
      partialCount: 2,
      paidCount: 2,
      cancelledCount: 2,
      value: 6000,
      max: 200,
      jobType: "service",
      invoicestatuses: [
        {
          label: "Draft",
          color: "cyan",
          textColor: "cyan--text",
          count: 0,
          value: 0,
          data_field: "draft",
        },
        {
          label: "Sent",
          color: "purple",
          textColor: "purple--text",
          count: 0,
          value: 0,
          data_field: "sent",
        },
        {
          label: "Partially Paid",
          color: "warning",
          textColor: "warning--text",
          count: 0,
          value: 0,
          data_field: "partially paid",
        },
        {
          label: "Paid",
          color: "green",
          textColor: "green--text",
          count: 0,
          value: 0,
          data_field: "paid",
        },
        {
          label: "Cancelled",
          color: "red",
          textColor: "red--text",
          count: 0,
          value: 0,
          data_field: "canceled",
        },
      ],
      quotationPerson: [
        // { name: "Lean", value: 4, quotationNo: "QT00006", color: "green" },
      ],
      selectedSalesPerson: "",
      quotationStatuses: [
        { label: "All Quotations", value: 88, textClass: "cyan--text" },
        { label: "Draft", value: 43, textClass: "cyan--text" },
        { label: "Accepted", value: 4, textClass: "success--text" },
        //{ label: "Pending For Approval", value: 12, textClass: "green--text" },
        //{ label: "Unapproval", value: 12, textClass: "green--text" },
        //{ label: "Approved", value: 12, textClass: "green--text" },
        { label: "Rejected", value: 1, textClass: "red--text" },
        { label: "Sent", value: 4, textClass: "orange--text" },
      ],
      jobTypeList: [
        { text: "Service", value: "service" },
        { text: "Installation", value: "installation" },
        { text: "Call Out", value: "call" },
        { text: "Training", value: "training" },
      ],
      quoStatusseries: [1, 1, 1, 1], // DEFAULT VALUE
      quoStatuschartOptions: {
        chart: {
          width: 450,
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        colors: ["#00bcd4", "#0abb87", "#f44336", "#ff9800"],
        labels: ["Draft", "Accepted", "Rejected", "Sent"],
        dataLabels: {
          enabled: true,
        },
        fill: {
          type: "gradient",
        },
        legend: {
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
        },
        title: {
          text: "Record Count",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 250,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
      customerDuration: "this_month",
      engcustomerDuration: "this_month",
      quotationStatus: "",
      engineerdurationList: [
        { text: "This Month", value: "this_month" },
        { text: "Last Month", value: "last_month" },
      ],

      jobByEngineerseries: [
        {
          name: "Draft",
          data: [44, 55, 41, 37, 22],
        },
        {
          name: "Accepted",
          data: [53, 32, 33, 52, 13],
        },
        {
          name: "Rejected",
          data: [12, 17, 11, 9, 15],
        },
        {
          name: "Sent",
          data: [9, 7, 5, 8, 6],
        },
      ],
      jobByEngineerchartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        colors: ["#008ffb", "#00e396", "#feb019", "#ff4560"],
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [
            "Michaela",
            "Rana",
            "Sally",
            "Ajai",
            "George",
            // "Terrence",
            // "Leon",
            // "Leowon",
            // "Chelsea",
          ],
          labels: {
            formatter: function (val) {
              return val + "";
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
      },
      newClosedJobsseries: [
        {
          name: "New ",
          data: [28, 29, 33, 36, 32, 32, 33],
        },
        {
          name: "Closed ",
          data: [12, 11, 14, 18, 17, 13, 13],
        },
      ],
      newInvoiceClosedJobsseries: [
        {
          name: "New ",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Due ",
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
      newClosedJobschartOptions: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#4CAF50", "#F44336"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Average New & Closed Jobs",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"], // default values
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Jobs",
          },
          min: 1,
          max: 100,
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
      // ADDING NEW object for invioice newClosedJobschartOptions\
      newInvoiceClosedJobschartOptions: {
        chart: {
          height: 350,
          type: "line",
          dropShadow: {
            enabled: true,
            color: "#000",
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2,
          },
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#4CAF50", "#F44336"],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        title: {
          text: "Average New & Closed Jobs",
          align: "left",
        },
        grid: {
          borderColor: "#e7e7e7",
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        markers: {
          size: 1,
        },
        xaxis: {
          categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"], // default values
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Jobs",
          },
          min: 1,
          max: 100,
        },
        legend: {
          position: "top",
          horizontalAlign: "right",
          floating: true,
          offsetY: -25,
          offsetX: -5,
        },
      },
      // ADDING NEW object for invioice newClosedJobschartOptions
      categoryList: [
        { text: "Open", value: "open" },
        { text: "Closed", value: "closed" },
        { text: "Overdue", value: "overdue" },
      ],
      isCategory: "open",
      invoicesdurationList: [
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "Last 3 Month", value: "last-3month" },
        { text: "Last 6 Month", value: "last-6month" },
      ],
      isInvoicesDuration: "this_month",
      isInvoicesCollectedDuration: "this_month",
      durationList: [
        { text: "This Week", value: "this_week" },
        { text: "This Month", value: "this_month" },
        { text: "Last 3 Month", value: "last-3month" },
        { text: "Last 6 Month", value: "last-6month" },
      ],
      isDuration: "this_month",
    };
  },

  methods: {
    getBgColor(color) {
      switch (color) {
        case "cyan":
          return "#00bcd4";
        case "green":
          return "#4CAF50";
        case "red":
          return "#F44336";
        case "blue":
          return "#ff9800";
        case "orange":
          return "#F4511E";
        case "yellow":
          return "#FFAB40";
        case "indigo":
          return "#3f51b5";
        case "purple":
          return "#9c27b0";
        default:
          return "#e0e0e0";
      }
    },
    randomValue() {
      this.value = Math.random() * this.max;
    },
    onBarClick(index, issue) {
      this.activeIndex = index;
      // const selectedPerson = this.quotationPerson[index];
      this.selectedSalesPerson = issue.prepared_by_id;
      this.getSalesContractOverview();

      this.disableOtherBars(index);
    },

    // new

    disableOtherBars(selectedIndex) {
      const defaultColors = ["#008ffb", "#00e396", "#feb019", "#ff4560"];
      const preColor = defaultColors.map((color, index) =>
        index === selectedIndex ? color : "#d3d3d3"
      );
      this.jobCategorychartOptions = {
        ...this.jobCategorychartOptions,
        colors: preColor,
      };
    },
    // new

    // new implementation of dynamic donut quotation

    // ending new

    onBarClickQuotation(event, chartContext, config) {
      const clickedIndex = config.dataPointIndex;
      this.activeIndex = null;

      const statusMap = {
        0: 1,
        1: 2,
        2: 3,
        3: 5,
      };

      const selectedStatus = statusMap[clickedIndex];

      this.quotationStatus = selectedStatus;

      // set the selected status
      switch (selectedStatus) {
        case 1:
          this.SelectedquotationStatus = "Draft";
          break;
        case 2:
          this.SelectedquotationStatus = "Accepted";
          break;
        case 3:
          this.SelectedquotationStatus = "Rejected";
          break;
        case 5:
          this.SelectedquotationStatus = "Sent";
          break;
        default:
          this.SelectedquotationStatus = "All";
          break;
      }
      // set the selected status

      this.getSalesContractOverview();
      this.disableOtherQuotationBars(clickedIndex);
    },

    // Modify getSalesContractOverview to accept status parameter

    disableOtherQuotationBars(selectedIndex) {
      const defaultColors = ["#00bcd4", "#0abb87", "#f44336", "#ff9800"];
      const preColor = defaultColors.map((color, index) =>
        index === selectedIndex ? color : "#d3d3d3"
      );
      this.quoStatuschartOptions = {
        ...this.quoStatuschartOptions,
        colors: preColor,
      };
    },

    // adding the changes for the dashboard integration api calling
    getSalesContractOverview() {
      const _this = this;
      _this.countLoading = true; // Show loading state

      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "sales_contract",
              data: {
                filter: _this.customerDuration || "this_month",
                acp_rej_filter: _this.isDuration || "last-6month",
                sales_persons: _this.selectedSalesPerson || "",
                all_sales_persons: _this.engcustomerDuration || "this_month",
                quotation_status: _this.quotationStatus || 2,
              },
            })
            .then(({ data }) => {
              _this.quotationPerson = data.salesPerson.map((person, index) => ({
                ...person,
                color: _this.getColorForIndex(index),
                value: parseFloat(person.value).toFixed(2),
              }));

              if (data.salesData && data.salesData.length > 0) {
                const statusData = data.salesData[0];
                if (statusData.quoStatusSeries.every((value) => value === 0)) {
                  _this.quoStatusseries = [1, 1, 1, 1];
                  _this.quoStatuschartOptions = {
                    ..._this.quoStatuschartOptions,
                    colors: ["#e0e0e0", "#e0e0e0", "#e0e0e0", "#e0e0e0"],
                    tooltip: {
                      enabled: true,
                      y: {
                        formatter: function () {
                          return "No data available yet!";
                        },
                      },
                    },

                    labels: [
                      "Draft (0)",
                      "Accepted (0)",
                      "Rejected (0)",
                      "Sent (0)",
                    ],
                    legend: {
                      ...(_this.quoStatuschartOptions.legend || {}),
                      formatter: function (val) {
                        return val + " - 0";
                      },
                    },
                  };
                } else {
                  _this.quoStatusseries = statusData.quoStatusSeries;
                }
              }

              _this.newClosedJobsseries = [
                {
                  name: "New ",
                  data: data.acceptGraph.accepted,
                },
                {
                  name: "Closed  ",
                  data: data.acceptGraph.rejected,
                },
              ];

              _this.newClosedJobschartOptions = {
                ..._this.newClosedJobschartOptions,
                xaxis: {
                  ..._this.newClosedJobschartOptions.xaxis,
                  categories: data.acceptGraph.months,
                },
                yaxis: {
                  max:
                    Math.max(
                      ...data.acceptGraph.accepted,
                      ...data.acceptGraph.rejected
                    ) + 10,
                  min:
                    Math.min(
                      ...data.acceptGraph.accepted,
                      ...data.acceptGraph.rejected
                    ) - 5,
                },
              };

              _this.slides = data.allSalesPersons
                // First sort the sales persons by value
                .sort((a, b) => parseFloat(b.value) - parseFloat(a.value))
                // Then map them to slides with appropriate ranks

                .map((person, index) => {
                  // Determine rank details based on position
                  const rankDetails = (() => {
                    switch (index) {
                      case 0:
                        return {
                          rankColor: "#ffd700", // Gold Rank 1
                          rankText: "Rank 1",
                          rankIcon: "mdi-crown",
                          swipeCount: "one",
                        };
                      case 1:
                        return {
                          rankColor: "#C0C0C0", // Silver
                          rankText: "Rank 2",
                          rankIcon: "",
                          swipeCount: "two",
                        };
                      case 2:
                        return {
                          rankColor: "#CD7F32", // Bronze
                          rankText: "Rank 3",
                          rankIcon: "",
                          swipeCount: "three",
                        };
                      default:
                        return {
                          rankColor: "#C0C0C0", //   for others
                          rankText: `Rank ${index + 1}`,
                          rankIcon: "",
                          swipeCount: toWords(index + 1),
                        };
                    }
                  })();

                  return {
                    avatar: _this.lodash.isEmpty(person.avatar)
                      ? "https://cdn.vuetifyjs.com/images/lists/2.jpg"
                      : person.avatar,
                    name: _this.lodash.isEmpty(person.name)
                      ? "Unknown"
                      : person.name,
                    value: parseFloat(person.value).toFixed(2),
                    quotationNo: person.quotationNo,
                    ...rankDetails,
                  };
                });
              this.initSwiper();
              // slides of sales person
              _this.countLoading = false;
              resolve(data);
            })
            .catch((error) => {
              _this.countLoading = false;
              reject(error);
            });
        } catch (error) {
          _this.countLoading = false;
          reject(error);
        }
      });
    },

    initSwiper() {
      this.swiper = new Swiper(".swiper", {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 4,
          slideShadows: true,
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        keyboard: {
          enabled: true,
        },
        mousewheel: {
          thresholdDelta: 70,
        },
        breakpoints: {
          560: {
            slidesPerView: 23,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 3,
          },
        },
        initialSlide: 0,
      });
    },
    getColorForIndex(index) {
      const colors = ["green", "blue", "cyan", "orange", "red"];
      return colors[index % colors.length];
    },
    validateFilter(filter) {
      const validFilters = [
        "this_week",
        "this_month",
        "last-3month",
        "last-6month",
      ];
      if (!validFilters.includes(filter)) {
        console.warn(`Invalid filter: ${filter}, using default 'this_month'`);
        return "this_month";
      }
      return filter;
    },

    resetFilterQuotationSales(type = "") {
      const commonResets = {
        sales: () => {
          this.jobByEngineerseries = "";
          this.engcustomerDuration = "this_month";
          this.quotationStatus = 2;
          this.selectedSalesPerson = "";
          this.activeIndex = null;
          this.customerDuration = "this_month";
          this.getSalesContractOverview();
        },
        quotation: () => {
          this.quoStatuschartOptions = {
            ...this.quoStatuschartOptions,
            colors: ["#00bcd4", "#0abb87", "#f44336", "#ff9800"],
          };
          this.quoStatusseries = [1, 1, 1, 1];
          this.quotationStatus = 2;
          this.engcustomerDuration = "this_month";
          this.jobByEngineerseries = "";
          this.selectedSalesPerson = "";
          this.activeIndex = null;
          this.customerDuration = "this_month";
          this.getSalesContractOverview();
        },
        "job-acpt-rej": () => {
          this.isDuration = "this_month";
          this.getSalesContractOverview();
        },
        "invoice-counts": () => {
          this.isInvoicesDuration = "this_month";
          this.getInvoiceCount();
        },
        "invoice-acpt-rej": () => {
          this.isInvoicesCollectedDuration = "this_month";
          this.getInvoiceCount();
        },
      };

      if (commonResets[type]) {
        commonResets[type]();
      }
    },
    getInvoiceCount() {
      const _this = this;
      _this.countLoading = true; // Show loading state
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "invoice_count",
              data: {
                date_range: _this.isInvoicesDuration || "this_month",
                invoice_range: this.isInvoicesCollectedDuration || "this_month",
              },
            })
            .then(({ data }) => {
              _this.invoicestatuses.forEach((stat) => {
                const matchingStatus = data.invoice_count.find(
                  (item) => item.invoice_status === stat.data_field
                );

                if (matchingStatus) {
                  stat.count = matchingStatus.invoice_count || 0;
                  stat.value =
                    Number(matchingStatus.total_amount.replace(/,/g, "")) || 0;
                } else {
                  stat.count = 0;
                  stat.value = "0.00";
                }
              });

              // populating line graph of invoice close,accepted
              _this.newInvoiceClosedJobsseries = [
                {
                  name: "New ",
                  data: data.acceptGraph.accepted_amount,
                },
                {
                  name: "Closed  ",
                  data: data.acceptGraph.rejected_amount,
                },
              ];

              _this.newInvoiceClosedJobschartOptions = {
                ..._this.newInvoiceClosedJobschartOptions,
                xaxis: {
                  ..._this.newInvoiceClosedJobschartOptions.xaxis,
                  categories: data.acceptGraph.months,
                },
                yaxis: {
                  max:
                    Math.max(
                      ...data.acceptGraph.accepted_amount,
                      ...data.acceptGraph.rejected_amount
                    ) + 10,
                  min:
                    Math.min(
                      ...data.acceptGraph.accepted_amount,
                      ...data.acceptGraph.rejected_amount
                    ) - 5,
                },
              };
              // populating line graph of invoice close,accepted
              _this.countLoading = false;
              resolve(data);
            })
            .catch((error) => {
              _this.countLoading = false;
              reject(error);
            });
        } catch (error) {
          _this.countLoading = false;
          reject(error);
        }
      });
    },
  },

  mounted() {
    this.getInvoiceCount();
    this.$watch(
      () => ({
        customerDuration: this.customerDuration,
        isDuration: this.isDuration,
        engcustomerDuration: this.engcustomerDuration,
      }),
      () => {
        this.getSalesContractOverview();
      },
      { deep: true }
    );
    this.$watch(
      () => ({
        isInvoicesDuration: this.isInvoicesDuration,
        isInvoicesCollectedDuration: this.isInvoicesCollectedDuration,
      }),
      () => {
        this.getInvoiceCount();
      },
      { deep: true }
    );
    this.getSalesContractOverview();
  },
  watch: {
    customerDuration(newVal) {
      if (newVal) {
        this.getSalesContractOverview();
      }
    },
    isDuration(newVal) {
      if (newVal) {
        this.getSalesContractOverview();
      }
    },
    engcustomerDuration(newVal) {
      if (newVal) {
        this.getSalesContractOverview();
      }
    },
    isInvoicesDuration(newVal) {
      if (newVal) {
        this.getInvoiceCount();
      }
    },
    isInvoicesCollectedDuration(newVal) {
      if (newVal) {
        this.getInvoiceCount();
      }
    },
  },
};
</script>

<style scoped src="@/assets/sass/dashboard.scss" lang="scss"></style>
